import React from "react"

import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"

export default function SignUp() {
  return (
    <Layout title="Reset Password">
      <FormContainer>
        <h1>Reset Password</h1>
      </FormContainer>
    </Layout>
  )
}
